import { useEffect, useState } from 'react';
import useGetAllUserPlans from './useGetAllUserPlans';
import useGetUserAppointments from './useGetUserAppointments';
import { BoolEnum } from '../API';
const useCheckMembership = (userId: string) => {
  const [issCompleted, setIssCompleted] = useState(false);
  const [hasActivePaidPlan, setHasActivePaidPlan] = useState(false);
  //check the user plan
  const { data: plans } = useGetAllUserPlans(userId);
  //check appointments books
  const { data: appts } = useGetUserAppointments(userId);

  useEffect(() => {
    if (plans && appts) {
      if (appts.length > 0) setIssCompleted(true);
      if (plans.length > 0 && plans[0]?.cancelled === BoolEnum.FALSE && (plans[0]?.plan?.defaultPrice ?? 0) > 0) setHasActivePaidPlan(true);
    }
  }, [plans, appts]);

  return { plans, appts, issCompleted, hasActivePaidPlan };
};

export default useCheckMembership;
